import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js";
import i18n from "@/plugins/i18n";
import Home from "./pages/Home";
import Survey from "./pages/Survey";
import Summary from "./pages/Summary";
import SummaryLoading from "./pages/SummaryLoading";
import Contact from "./pages/Contact";
import ContactSend from "./pages/ContactSend";
import ResultsInvoice from "./pages/ResultsInvoice";
import Privacy from "./pages/Privacy";
import Results from "./pages/Results";
import NotFound from "./pages/NotFound";
import survey from "@/survey";
import * as HeaderType from "./headerType";

Vue.use(Router);

const router = new Router({
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
			};
		}
		if (savedPosition) {
			return savedPosition;
		}
		if (window.innerWidth < 600 && from && to.name !== "home") {
			return { x: 0, y: 85 };
		}
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/:tenant",
			component: {
				render(createElement) {
					return createElement("router-view", {
						on: this.$listeners,
					});
				},
			},
			redirect: "/:tenant/en",
			beforeEnter: (to, from, next) => {
				Promise.all([
					store.dispatch("fetchTenant", to.params.tenant),
					// Survey backend component needs to be refactored as a store module
					survey.loadSurvey(to.params.tenant),
				])
					.then(() => {
						document.title = store.state.tenant.metadata.prettyName;
						i18n.locale = to.params.lang;
						const languages = store.getters.languages;
						i18n.locale = languages.includes(to.params.lang) ? to.params.lang : languages[0];

						if (!languages.includes(to.params.lang))
							next({
								...to,
								params: { ...to.params, lang: i18n.locale },
								replace: true,
							});
						else next();
					})
					.catch(e => {
						next({ name: "notfoundglobal" });
					});
			},
			children: [
				{
					path: ":lang(nl|en)",
					component: {
						render(createElement) {
							return createElement("router-view", {
								on: this.$listeners,
							});
						},
					},
					children: [
						{
							path: "/",
							name: "home",
							component: Home,
							meta: {
								header: HeaderType.GETTING_STARTED_HEADER,
							},
						},
						{
							path: "survey",
							name: "survey",
							component: Survey,
							meta: {
								header: HeaderType.STEPPER_HEADER,
							},
							props: (route) => ({
								category: Number.parseInt(route.query.category) || undefined,
								question: Number.parseInt(route.query.question) || undefined,
							}),
						},
						{
							path: "summary/loading",
							name: "summaryLoading",
							component: SummaryLoading,
							meta: {
								header: HeaderType.CONTACT_PAGE_HEADER,
							},
						},
						{
							path: "summary",
							name: "summary",
							component: Summary,
							meta: {
								header: HeaderType.CONTACT_PAGE_HEADER,
							},
						},
						{
							path: "contact",
							name: "contact",
							component: Contact,
							meta: {
								header: HeaderType.EMPTY_HEADER,
							},
						},
						{
							path: "contact/send",
							name: "contactSend",
							component: ContactSend,
							meta: {
								header: HeaderType.EMPTY_HEADER,
							},
						},
						{
							path: "privacy",
							name: "privacy",
							component: Privacy,
							meta: {
								header: HeaderType.PRIVACY_POLICY_HEADER,
							},
						},
						{
							path: "results/:uuid/invoice",
							name: "ResultsInvoice",
							component: ResultsInvoice,
							props: true,
							meta: {
								header: HeaderType.EMPTY_HEADER,
							},
						},
						{
							path: "results/:uuid",
							name: "Results",
							component: Results,
							props: true,
							meta: {
								header: HeaderType.EMPTY_HEADER,
							},
						},
						{
							path: "*",
							name: "notfound",
							component: NotFound,
							meta: {
								header: HeaderType.EMPTY_HEADER,
							},
						},
					],
				},
			],
		},
		{
			path: "/notfoundtenant",
			alias: "*",
			name: "notfoundglobal",
			component: NotFound,
			meta: {
				header: HeaderType.EMPTY_HEADER,
			},
		},
	],
});

export default router;
